import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTicketAlt, faUserCog, faHeadset, faGavel, faChartLine } from "@fortawesome/free-solid-svg-icons"; // 필요한 아이콘 추가
import { AuthContext } from "../../context/AuthContext";
import {
  Header,
  Container,
  HeaderWrapper,
  LogoContainer,
  LogoImage,
  Nav,
  NavLink,
  RightMenu,
  MenuItem,
  LogoutLabel,
  Icon
} from './NavigatorStyles';
import logoimage from "../../static/CineChain.png";

import styled, { keyframes } from 'styled-components';

const TimeDisplay = styled.div`
  font-size: 14px;
  color: #666;
`;

const blinking = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
`;

const BlinkingLink = styled(NavLink)`
  color: red;
  animation: ${blinking} 1s infinite;
`;

export default function Navigator() {
  const { isLoggedIn, user, logout } = useContext(AuthContext);
  const [hasUserOrders, setHasUserOrders] = useState(false);
  const [hasAuctionOrders, setHasAuctionOrders] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());
  const [ordersChecked, setOrdersChecked] = useState(false); // 주문이 확인되었는지 여부
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await fetch('/agent-orders/getOrders', {
          credentials: 'include', // 세션 정보를 포함하여 요청
        });
        if (!response.ok) {
          throw new Error('주문을 가져오는 중 오류 발생');
        }
        const data = await response.json();
        setHasUserOrders(data.userOrders.length > 0);
        setHasAuctionOrders(data.auctionOrders.length > 0);
        setOrdersChecked(true); // 주문이 확인되었음을 표시
      } catch (error) {
        console.error('주문을 가져오는 중 오류 발생:', error);
        navigate('/login');
      }
    };

    // 유저가 있고 아직 주문이 확인되지 않았다면 fetchOrders를 호출
    if (user && !ordersChecked) {
      fetchOrders();
    }
  }, [user, ordersChecked]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);
    
    return () => clearInterval(timer); // Cleanup the interval on component unmount
  }, []);



  return (
    <Header>
      <HeaderWrapper>
        <Container>
          <Nav>
            <NavLink to="/Tiketting/AssignOrder">
              <FontAwesomeIcon icon={faTicketAlt} /> 예매대행
            </NavLink>
            <NavLink to="/Settings/MyPage">
              <FontAwesomeIcon icon={faUserCog} /> 계정 관리
            </NavLink>
          </Nav>

          {isLoggedIn && user && hasUserOrders && (
            <BlinkingLink to="/Tiketting/AssignOrder">
              <FontAwesomeIcon icon={faGavel} /> 대행이 할당되었습니다
            </BlinkingLink>
          )}

          {isLoggedIn && user && hasAuctionOrders && (
            <NavLink to="/Tiketting/AgentUserOrders">
              <FontAwesomeIcon icon={faGavel} /> 공개경매
            </NavLink>
          )}

          <NavLink to="/MoviePrice">
            <FontAwesomeIcon icon={faChartLine} /> 영화시세
          </NavLink>

          <NavLink to="/CSCenter/Notices">
            <FontAwesomeIcon icon={faHeadset} /> 고객센터
          </NavLink>
        </Container>
      </HeaderWrapper>
    </Header>
  );
}
